var _circle, _circle2, _circle3, _circle4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfferNotValid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#EAECF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 99.5,
    stroke: "#1B3554",
    strokeOpacity: 0.0198992
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5878_57572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 99.5,
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5878_57572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9834 70.6777C38.9834 54.1092 52.4149 40.6777 68.9834 40.6777H131.017C147.586 40.6777 161.017 54.1092 161.017 70.6777V201.695H38.9834V70.6777Z",
    fill: "white",
    stroke: "#D0D5DD",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.915,
    y: 72.8818,
    width: 109.322,
    height: 128.814,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.415,
    y: 73.3818,
    width: 108.322,
    height: 127.814,
    stroke: "#1B3554",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5878_57572)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.3896,
    y: 81.3564,
    width: 92.3729,
    height: 33.8983,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 89,
    width: 58,
    height: 3.38983,
    rx: 1.69492,
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 95.7793,
    width: 42.3846,
    height: 3.38983,
    rx: 1.69492,
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.55,
    x: 82,
    y: 104.254,
    width: 12.641,
    height: 3.38983,
    rx: 1.69492,
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_5878_57572)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 90,
    width: 18,
    height: 18,
    rx: 9,
    fill: "url(#paint0_linear_5878_57572)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.182 103.467L68 100.285L64.818 103.467L63.7574 102.406L66.9393 99.2244L63.7574 96.0424L64.818 94.9818L68 98.1638L71.182 94.9818L72.2426 96.0424L69.0607 99.2244L72.2426 102.406L71.182 103.467Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5878_57572)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.3896,
    y: 123.356,
    width: 92.3729,
    height: 33.8983,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 131,
    width: 58,
    height: 3.38983,
    rx: 1.69492,
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 137.779,
    width: 42.3846,
    height: 3.38983,
    rx: 1.69492,
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.55,
    x: 82,
    y: 146.254,
    width: 12.641,
    height: 3.38983,
    rx: 1.69492,
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_5878_57572)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 132,
    width: 18,
    height: 18,
    rx: 9,
    fill: "url(#paint1_linear_5878_57572)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.182 145.467L68 142.285L64.818 145.467L63.7574 144.406L66.9393 141.224L63.7574 138.042L64.818 136.982L68 140.164L71.182 136.982L72.2426 138.042L69.0607 141.224L72.2426 144.406L71.182 145.467Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5878_57572",
    x: 47.3896,
    y: 78.3564,
    width: 104.373,
    height: 45.8984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5878_57572"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5878_57572",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_5878_57572",
    x: 51,
    y: 82,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5878_57572"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5878_57572",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5878_57572",
    x: 47.3896,
    y: 120.356,
    width: 104.373,
    height: 45.8984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5878_57572"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5878_57572",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_5878_57572",
    x: 51,
    y: 124,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5878_57572"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5878_57572",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5878_57572",
    x1: 61,
    y1: 104.5,
    x2: 75,
    y2: 93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5878_57572",
    x1: 61,
    y1: 146.5,
    x2: 75,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8960"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferNotValid);
export default __webpack_public_path__ + "static/media/offer-not-valid.d8825794fe8c112e86ab8b810b7dbf6f.svg";
export { ForwardRef as ReactComponent };